/*globals $*/
'use strict';

const getValidationFunctions = () => import("./validate");

$( document ).ready(function() {

    $('#hundreds__contact-form #hundreds__contact_submit-button').on('click', function(e){
        console.log('contact');
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateContactForm();
        });
    });

    $('#hundreds__newsletter-form #hundreds__newsletter_submit-button').on('click', function(e){
        console.log('newsletter');
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateNewsletterForm();
        });
    });

    $('#hundreds__opinion-form #hundreds__opinion_submit-button').on('click', function(e){
        console.log('opinion');
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateOpinionForm();
        });
    });

    $('#hundreds__openlab-form #hundreds__openlab_submit-button').on('click', function(e){
        console.log('openlab');
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateOpenlabForm();
        });
    });

    $('#hundreds__download-form #hundreds__download_submit-button').on('click', function(e){
        console.log('download');
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateDownloadForm();
        });
    });


    $('.download-button__file').on('click', function(){
        var email = localStorage.getItem('hundreds__download-email___girbaulab');
        if( email == 'hundreds-email-ok' ){
            downloadURI( $(this).attr('data-file'), $(this).attr('data-filename') );
        }else{
            $('#hundreds__download_file').val( $(this).attr('data-file') );
            $('#hundreds__download_filename').val( $(this).attr('data-filename') );
            $('#download__popup').show();
        }
    });

    $('#remove-popup__download').on('click', function(){
        $('#download__popup').hide();
    });

    $('#hundreds__access-form #hundreds__access_submit-button').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateAccessForm();
        });
    });
});

function downloadURI(uri, name) 
{
    var link = document.createElement("a");
    // If you don't know the name or want to use
    // the webserver default set name = ''
    link.setAttribute('download', name+'.pdf') ;
    link.setAttribute('href', uri );
    document.body.appendChild(link);

    console.log( link );

    link.click();
    link.remove();
}
